import { NotificationStyledAttrProps } from './types';
import styled from 'styled-components';
import { colors } from '../../const/color';
import { font } from '../../const/font';
import { IconStyled } from '../icon';

export const NotificationStyled = styled('div')<NotificationStyledAttrProps>`
  min-height: 48px;
  position: relative;
  background-color: ${({ $type }) => ($type === 'success' ? colors.success : colors.error)};
  color: ${colors.white};
  font-size: ${font.size.sm};
  padding: 15px 15px 15px 60px;
  text-align: right;
  box-shadow: 0px 8px 56px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  & > ${IconStyled} {
    width: 60px;
    height: 48px;
    display: block;
    position: absolute;
    text-align: center;
    padding: 15px;
    box-sizing: border-box;
    top: 50%;
    transform: translateY(-50%);
    left: 0;

    svg,
    svg * {
      fill: ${colors.white};
    }
  }
  span {
    text-align: left;
    display: block;
    word-break: break-word;
  }
  button,
  a {
    background-color: transparent;
    color: ${colors.white};
    font-size: ${font.size.xs};
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    display: block;
    line-height: 20px;
    padding: 14px 15px;
    border: none;
    margin: -15px -15px -15px 0;
    letter-spacing: 1.65px;
    &:hover {
      border: none;
      background-color: transparent;
    }
  }
`;
